import React from "react";
import "../../screens/Login.scss";

export const SideLayout = () => {
  return (
    <div className="login sidebar">
      <div className="sidebar-content">
        <div className="desktop-view-container text-center">
          <img src="/assets/images/loop-health-logo.png" alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 mx-auto text-center">
          <div className="text-center login-bg-side-container">
            <img
              className="lh-login-bottom-image"
              src="assets/images/login-sidebar.svg"
              alt=""
            />
          </div>
          <h4 className="sidebar-title">Making Enrolment Process Easy</h4>
          <p className="intro-subtitle text-center mt-2">
            Let's Begin your Enrollment
          </p>
        </div>
      </div>
    </div>
  );
};
